import { BaseOption } from '@/hooks/useTypeToOptions';
import { useTranslation } from '@/i18n';
import { useMemo } from 'react';

export const useTypeOptions = (): BaseOption[] => {
  const { t } = useTranslation();

  return useMemo(
    () => [
      {
        label: t('import_export_history_type_import'),
        value: 'import',
      },
      {
        label: t('import_export_history_type_export'),
        value: 'export',
      },
    ],
    [t]
  );
};
